module.exports = __webpack_public_path__ + "static/img/19078D_2_R_20201021_fit.4816801.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19078D_2_R_20201021_fit.png
// module id = AFin
// module chunks = 0